// utils/layerUtils.js

import { addLayer, removeLayer } from '../../utils/addingLayers/AddVoltagesLayers';

export const toggleLayerHelper = async ({
    checked,
    layerName,
    networkType = '',
    yearToFilter = null,
    getAll = false,
    setHoverInfo,
    handleClickInfo,
    setWmsLayers,
    viewState,
    setViewState,
    setOverlay,
    id_terenske_jedinice,
    setWfsLayers,
    setNetworkType
}) => {
    const hasSuffix = ["vod", "dionica", "stubovi"].includes(layerName);
    const layerIdBase = hasSuffix ? `${layerName}-${networkType}` : layerName;

    if (checked) {
        const newLayers = await addLayer(
            layerName,
            setHoverInfo,
            handleClickInfo,
            yearToFilter,
            setWmsLayers,
            networkType,
            viewState,
            setViewState,
            getAll,
            setOverlay,
            id_terenske_jedinice
        );

        if (layerName === "vod") {
            setNetworkType(networkType);
            const sectionLayer = await addLayer(
                "dionica",
                setHoverInfo,
                handleClickInfo,
                yearToFilter,
                setWmsLayers,
                networkType,
                viewState,
                setViewState,
                getAll,
                setOverlay,
                id_terenske_jedinice
            );

            if (sectionLayer) {
                setWfsLayers(prev => [...prev, ...(Array.isArray(sectionLayer) ? sectionLayer : [sectionLayer])]);
            }
        }

        if (newLayers) {
            setWfsLayers(prev => [...prev, ...(Array.isArray(newLayers) ? newLayers : [newLayers])]);
        }

        return;
    }

    setWfsLayers(prev =>
        prev.filter(
            layer =>
                !layer.id.includes(layerIdBase) &&
                !(layerName === "vod" && layer.id.includes(`dionica-${networkType}`))
        )
    );

    setWmsLayers(prev =>
        prev.filter(
            layer =>
                !layer.id.includes(layerIdBase) &&
                !(layerName === "vod" && layer.id.includes(`dionica-${networkType}`))
        )
    );
};

export const handleSidebarClose = ({
    checkFlag,
    setFlags,
    layerPrefixes,
    setWfsLayers,
    setWmsLayers,
    closeSidebar,
    handleSidebarToggle,
    netType
}) => {
    const hasHierarchyLayers = (prevLayers) => {
        return layerPrefixes.some(prefix =>
            prevLayers.some(layer =>
                layer.id.startsWith(prefix) &&
                (netType ? !layer.id.includes(netType) : true)
            )
        );
    };

    const shouldRemoveLayer = (layer) => {
        return layerPrefixes.some(prefix => layer.id.startsWith(prefix)) &&
            (netType ? !layer.id.includes(netType) : true);
    };

    setWfsLayers(prev => {
        if (checkFlag && hasHierarchyLayers(prev)) {
            setFlags.forEach(fn => fn(false));
            handleSidebarToggle?.(null);
            return prev.filter(layer => !shouldRemoveLayer(layer));
        }
        return prev;
    });

    setWmsLayers(prev => {
        if (checkFlag && hasHierarchyLayers(prev)) {
            return prev.filter(layer => !shouldRemoveLayer(layer));
        }
        return prev;
    });

    closeSidebar();
};